module.exports = __webpack_public_path__ + "media/fstvideo2.f970d0a0.mp4";